/**
 * A section is either visible to signed-in staff only, or published to the
 * public knowledge base — see `db/schema/wiki.ts` for how this combines with
 * a page's own `isPublished` flag to decide what the public site can show.
 */
export const WIKI_SECTION_VISIBILITIES = ['internal', 'public'];
/** Generous — wiki pages are reference documents, not short blurbs like a
 *  product description. */
export const WIKI_PAGE_CONTENT_MAX = 100_000;
export const WIKI_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const COMBINING_DIACRITICS = /[̀-ͯ]/g;
/**
 * Turns a title into a URL-safe slug: lowercase, diacritics stripped,
 * anything that isn't a letter or digit collapsed to a single hyphen. Used
 * both as the API's default when a caller doesn't supply one, and by the
 * admin editor to preview the public URL as the title is typed.
 */
export function slugify(value) {
    return value
        .normalize('NFKD')
        .replace(COMBINING_DIACRITICS, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
//# sourceMappingURL=wiki.js.map